import { render } from "./CreateSiteStep5.vue?vue&type=template&id=2fbf850e&scoped=true"
import script from "./CreateSiteStep5.vue?vue&type=script&lang=js"
export * from "./CreateSiteStep5.vue?vue&type=script&lang=js"

import "./CreateSiteStep5.vue?vue&type=style&index=0&id=2fbf850e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbf850e"]])

export default __exports__